<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title dark>Документы</v-toolbar-title>
    </v-toolbar>
    <v-row>
      <list-view
        :items="documents"
        create-item="documents_create"
        items-name="documents"
        :with-sites="false"
        edit-item="documents_edit"
      ></list-view>
    </v-row>
  </v-container>
</template>

<script>
import ListView from '@/components/ListView'

export default {
  name: 'index',
  components: { ListView },
  data() {
    return {
      documents: [],
    }
  },
  // TODO: fix it
  watch: {
    '$attrs.site_key'() {
      this.updateData()
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    updateData() {
      this.axios({
        url: '/v1/documents',
        method: 'get',
        params: { site_key: this.$attrs.site_key },
      })
        .then((resp) => {
          if (resp) {
            this.documents = resp.data
          } else {
            this.documents = []
          }
        })
        .catch((err) => {
          this.showSnackbar(err.response.data)
        })
    },
  },
}
</script>
